import { Text } from "@assetwatch/ui";

export function MetricLabel({
  label,
  value,
}: {
  label: string;
  value: string;
}) {
  return (
    <Text as="div" size="sm">
      <span className="text-text-subtle">{label}</span> {value}
    </Text>
  );
}
